module.exports = __webpack_public_path__ + "img/Widgete.61a9474e.png";